import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import * as Vue from 'vue'
import {vueVersion} from './VueVersion'

/*
* https://github.com/ankurk91/vue-toast-notification
* */
export const toast = (title, message, type = 'success', toaster = 'top') => {
    if (vueVersion() == 2) {
        const vm = Vue
        let newVm = new vm.default()

        let toasterPosition = {
            'top-right': 'b-toaster-top-right',
            'top-left': 'b-toaster-top-left',
            'bottom-left': 'b-toaster-bottom-left',
            'bottom-right': 'b-toaster-bottom-right',
            'top': 'b-toaster-top-center',
        }

        newVm.$bvToast.toast(`${message}`, {
            title: `${title}`,
            variant: type,
            headerClass: 'text-left w-100',
            bodyClass: 'text-right',
            toaster: toasterPosition[toaster],
        })
    } else {
        const $toast = useToast();
        type = type == 'danger' ? 'error' : type
        $toast.success(message, {position: toaster, type: type});
    }


};